import React from "react";
import { DEFECT_KEY } from "../store/defect";
import { connect } from "react-redux";
import { Flags } from "@lectra/ld-react-feature-flags";

function mapStateToProps(state) {
  const isConnected = state.authentication[DEFECT_KEY] == null;
  return { isConnected };
}

function isConnected(Comp, fallback = null) {
  return props => {
    if (props.isConnected) {
      return <Comp {...props}></Comp>;
    } else {
      return fallback;
    }
  };
}

const MyFlag = isConnected(Flags);
export default connect(mapStateToProps)(MyFlag);
